import { render, staticRenderFns } from "./ThreadsToolbarMessageDialog.vue?vue&type=template&id=7c633f96"
import script from "./ThreadsToolbarMessageDialog.vue?vue&type=script&lang=ts"
export * from "./ThreadsToolbarMessageDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports